import { render, staticRenderFns } from "./SmsMessageTextField.vue?vue&type=template&id=68d3b02d"
import script from "./SmsMessageTextField.vue?vue&type=script&lang=js"
export * from "./SmsMessageTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports